import clsx from 'clsx';
import React, { useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import EnhancedPaywall from '@components/ProjectsPaywall/EnhancedPaywall';
import { AppContextProvider } from '@contexts/AppContext';
import useTrackEvent from '@hooks/useEventTracking';
import { Page } from '@tracking';

import Categories from './Categories';
import Header from './Header';
import Influentials from './Influentials';
import { ALL_CATEGORY, Top50InfluentialProps } from './interface';

const queryClient = new QueryClient();
const Top50Influential = ({
  categories,
  env,
  initialCurrentUser,
  isWebview,
  paywallData,
  project,
  projectData,
  unlocked,
}: Top50InfluentialProps) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState(ALL_CATEGORY);
  const { Track } = useTrackEvent({ page: Page.Top50Influential });
  const people = Array.isArray(projectData) ? projectData : [];

  return (
    <AppContextProvider env={env} initialCurrentUser={initialCurrentUser} isWebview={isWebview}>
      <QueryClientProvider client={queryClient}>
        <Track>
          <div
            className={clsx(
              !unlocked &&
                "pointer-events-none relative w-full select-none after:absolute after:-top-90 after:bottom-0 after:left-0 after:right-0 after:bg-black/30 after:content-[''] sm:after:-top-[140px]"
            )}
          >
            <header className="px-16 sm:px-28">
              <div className="mx-auto grid w-full min-w-0 max-w-container-lg">
                <Header
                  onSearchChange={setSearchQuery}
                  project={project}
                  searchQuery={searchQuery}
                  unlocked={unlocked}
                />
                {unlocked && (
                  <>
                    <span id="no-paywall"></span>
                    <Categories
                      categories={categories}
                      onSelectCategory={setSelectedCategory}
                      selectedCategory={selectedCategory}
                    />
                    <Influentials
                      projectData={people}
                      searchQuery={searchQuery}
                      selectedCategory={selectedCategory}
                    />
                  </>
                )}
              </div>
            </header>
            {!unlocked && (
              <div className="px-16 sm:px-28">
                <Influentials
                  className="mx-auto w-full min-w-0 max-w-container-lg pt-32 sm:pt-48"
                  projectData={people}
                  searchQuery=""
                  selectedCategory={ALL_CATEGORY}
                />
              </div>
            )}
          </div>
          {!unlocked && (
            <>
              <div className="relative before:absolute before:bottom-0 before:left-0 before:z-10 before:h-[300px] before:w-full before:bg-[linear-gradient(to_top,#fff_0%,rgba(255,255,255,0)_100%)]  dark:before:bg-[linear-gradient(to_top,#1a1a1a_0%,rgba(26,26,26,0)_100%)]"></div>
              <div className="sticky bottom-0 z-50">
                <EnhancedPaywall
                  headerClassName="!mx-0"
                  featureListClassName="!max-w-[620px]"
                  title={paywallData.title || ''}
                  subtitle={paywallData.subtitle || ''}
                  features={paywallData.features || []}
                  buttonText={paywallData.buttonText || ''}
                  offerLink={paywallData.offerLink || ''}
                  imagePath={paywallData.imagePath || ''}
                  isCurrentUserPresent={!!paywallData.isLoggedIn}
                  isPro={false}
                  leadType={project.leadType}
                  projectSlug={project.slug}
                />
              </div>
            </>
          )}
        </Track>
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default Top50Influential;
